import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnpin: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUnpin"><Path d="M8.5 15.5L3.5 20.5M11 7.65625L11.5 7.5L14.5 2.5L21.5 9.5L16.5 12.5L16.3438 13M2.5 2.5L21.5 21.5M8.15201 8.54625L3.5 10L14 20.5L15.4525 15.8518" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconUnpin;
